// Libraries
import React from 'react'

// Styles
import { StyledWrap, BookClosed, BookOpened } from './style'

export const Books = () => {
  return (
    <StyledWrap>
      <BookClosed src='/book.webp' />
      <BookOpened src='/book_opened.webp' />
    </StyledWrap>
  )
}
